import React from 'react';

const Gallery = () => {
	// fetch pictures of pujas and havans from backend and render here
	return <div>Gallery</div>;
};

export default Gallery;
